import React, { SetStateAction } from 'react';

import LabelSubscribersRowMobile from './LabelSubscribersRowMobile';
import { LabelSubscription, useLabelSubscribersContext } from './LabelSubscribersContext';
import useQueryLabelSubscribers from './useQueryLabelSubscribers';

interface Props {
  setSelectedSubscriber: React.Dispatch<SetStateAction<LabelSubscription>>;
  page: number;
}

/**
 * [LabelSubscribersListChunkMobile] - Renders a chunk of subscribers for the mobile view. This mobile list is
 * rendered in "chunks" or "pages" because our graphcache pagination wasn't working at the time of writing.
 * This approach lets us maintain a subscription to multiple pages of subscribers and invalidate the cache
 * after mutations.
 *
 * TODO: Refactor this to use graphcache pagination once it's working.
 */

const LabelSubscribersListChunkMobile = ({ setSelectedSubscriber, page }: Props) => {
  const { sortBy } = useLabelSubscribersContext();
  const { data: subscribers, fetching, pageInfo } = useQueryLabelSubscribers(page);

  return (
    <>
      {subscribers.map(subscriberData => (
        <LabelSubscribersRowMobile
          key={subscriberData.id}
          subscription={subscriberData}
          setSelectedSubscriber={setSelectedSubscriber}
          sortBy={sortBy}
        />
      ))}

      {fetching &&
        pageInfo.hasNextPage &&
        [...Array<undefined>(20)].map((_, index) => (
          <LabelSubscribersRowMobile.Tombstone key={index} index={index} />
        ))}
    </>
  );
};

export default LabelSubscribersListChunkMobile;
